/* eslint-disable */
export default {
  init() {
    $(document).on("submit", "#brochure_download", function (e) {
      e.preventDefault();

      const email = $("#brochure_email").val();
      const nonce = $("#_wpnonce").val();
      const ajax_url = $("#admin_ajax").val();
      if (!email) {
        $("#error_meesage").html("E-mail is missing!");
        return false;
      }
      if (!nonce) {
        $("#error_meesage").html("Something went wrong!");
      }
      $("#error_meesage").html("");
      const formData = {
        nonce,
        email,
        action: "brochure_download",
      };
      $.ajax({
        type: "post",
        url: ajax_url,
        data: formData,
        success: function (response) {
          $("#success_meesage").html("Check your email for the brochure");
        },
        error: function (error) {
          $("#error_meesage").html("Something went wrong!");
        },
      });
    });
  },
  finalize() {},
};
